<style lang="scss" scoped>
    .font-weight {
        font-weight: 800;
    }
    .inbound-package {
        right: 18px;
        top: 3px;
    }
    .other-form {
        .form-item {
            height: 42px;
            margin-bottom: 5px;
            clear: both;
        }
    }
</style>
<template>
    <div class="relative">
        <div style="display:flex;height: 300px">
            <compWrapper title="基本信息" theme="primary" style="width:50%; margin-right:10px">
                <compFormEdit ref="relation" align="center" class="margin-layout" :formdata="getBase" v-model="formData" :labelWidth="120"/>
            </compWrapper>
            <compWrapper title="计费项目" theme="success" style="width:50%;">
                <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll" style="padding-left:25%; margin:8px 0">全选</Checkbox>
                <CheckboxGroup v-if="this.type == 'edit'" v-model="countDataList" @on-change="checkAllGroupChange" style="display:flex; flex-direction:column; align-items:flex-start; padding-left:25%; height:200px; overflow:auto;">
                    <Checkbox v-for="(item,index) in countData" :key="index" :label="item" style="margin-bottom:8px"></Checkbox>
                </CheckboxGroup>
                <CheckboxGroup v-else v-model="countDataList" @on-change="checkAllGroupChange" style="display:flex; flex-direction:column; align-items:flex-start; padding-left:25%; height:200px; overflow:auto">
                    <Checkbox v-for="(item,index) in countDataListQuery" :key="index" :label="item" style="margin-bottom:8px"></Checkbox>
                </CheckboxGroup>
            </compWrapper>
        </div>

        
        
        <!-- 价格列表 -->
        <compWrapper title="价格列表" theme="info">
            <!-- 针对仓储费展示提示 -->
            <!-- <Alert class="margin-15" v-if="formData.expenseCategoryType == 1" show-icon>
                仓储费原计费体积单位为立方英尺（包仓除外），自2023年1月12日开始切换为立方米，请检查并更新报价，2023年1月12日之前生成的费用如需按立方米结算，可手动重新结算。
            </Alert> -->
            <vTable
            class="margin-15"
            style="z-index:2"
            :columns="columns"
            :data="newDatalist"
            size="small"
            ref="tabledoc"
            border></vTable>
            <vButtonGroup v-if="this.querytype !=='query'" class="absolute inbound-package">
                <vButton theme="success" @click="importExcel">导入</vButton>
                <vButton @click="exportExcel">导出</vButton>
            </vButtonGroup>
            <vButtonGroup v-if="this.querytype !=='query'" slot="footer">
                <Button type="primary" @click="submit">保存</Button>
                <Button class="margin-left-10" @click="cancel">取消</Button>
            </vButtonGroup>
        </compWrapper>

        <!-- 操作历史 -->
        <compWrapper title="操作历史" theme="gray" v-if="querytype=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-confirm="modalProps={}"
            @on-close="closemodalprops"
        >
        <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" @on-close="closemodalprops" v-on="modalProps.on"></component>
        </compModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>

    </div>
</template>

<script>
    import { mapState,mapGetters } from "vuex";
    import { HttpGetPriceMaintianBase, HttpGetPriceMaintianTable,HttpSavePriceMaintiantOne,HttpSavePriceMaintiantTable } from "@/service/newbigaccount";
    import {
        HttpGetBillingUnit,
        HttpGetAllBillingCondition,
    } from '@/service/bespeak';
    // 搜索品类

    import mixin from '../mixin'
    export default {
        mixins: [mixin],
        props:['activeid','querytype'],
        components:{
            compUpload: () =>  import("@components/templates/upload"),
            compWrapper: () => import("@components/templates/wrapper"),
            compFormQuery: () => import("@components/templates/formquery"),
            compFormEdit: () => import("@components/templates/formedit"),
        },
        data(){
            return {
                orgid: this.$route.query.orgid || this.activeid.organizationId,
                code:this.$route.query.code || this.activeid.expenseCategoryCustomizeCode,
                billtype:this.$route.query.billtype || this.activeid.billtype,
                type: this.$route.params.type || this.querytype,
                modalProps:{
                    show: false,
                },
                formData:{
                },
                countData:[],
                countDataList:[],
                countDataListQuery:[],
                indeterminate: false,
                checkAll: true,
                logList:[],
                datalist:[],
                newDatalist: [],
                startAllTime: '',
                endAllTime: '',
                loading:false,
                showDate:'',
                billUnitEnum:[],
                billConditionEnum:[],
            }
        },
        created(){
            // 查询计费单位与附加条件
            HttpGetBillingUnit().then(res=>{
                Object.keys(res.data).forEach((key)=>{
                    let jsonone = {
                        label:key,
                        value:res.data[key]
                    }
                    this.billUnitEnum.push(jsonone)
                })
            })
            HttpGetAllBillingCondition().then(res=>{
                this.billConditionEnum = res.data.map(item=>{
                    return {
                        value:item.code,
                        label:item.name
                    }
                })
            })
            this.update();
            this.showDate = this.type == 'edit' ? 'flex':'none';
        },
        watch :{
            'countDataList': {
                handler(val) {
                    this.changeNewDatalist(val);
                },
            },
        },
        computed:{
            ...mapGetters('dictionary', ['getCusBillTypeList']),
            ...mapGetters('common', ['getCurrencyList']),
            getBase(){
                return [
                    {
                        label: "费用类型",
                        tag:'Select',
                        key:'expenseCategoryType',
                        options:this.getCusBillTypeList,
                        query:this.type!='add',

                    },
                    {
                        label: "费用类型代码",
                        key: "code",
                        show:this.type!='add',
                        query:this.type!='add',
                    },
                    // {
                    // 	label: "费用单位",
                    // 	key: "currency",
                    //     tag: "vSelect",
                    //     options:this.getCurrencyList.map(item=>{
                    //         return {
                    //             value:item,
                    //             label:item
                    //         }
                    //     }),
                    //     query:this.querytype=='query',
                    // },

                ]
            },
            columns(){
                let _this = this;
                return [
                    {
                        title: 'code',
                        key: 'billingCategoryCode',
                    },{
                        title: '计费项目',
                        key: 'billingCategoryName'
                    }, {
                        title: '计费单位',
                        key: 'billingUnit',
                        render:(h,{ row, index })=>{
                            return <div>{this.getbillingUnit(row.billingUnit)}</div>
                        }

                    }, {
                        title: '名称',
                        key:'description',
                    },{
                        title: '规则分组',
                        key:'groupName',
                    },
                    {
                        title: '约束条件',
                        // key: 'billingCondition',
                        render:(h,{ row, index })=>{
                            if(row.billingCondition){
                                if(row.billingUnit == 900){
                                    return <div>{row.billingCondition}</div>
                                }else{
                                    return <div>{this.getbillConditionEnum(row.billingCondition) || '--' }</div>
                                }
                            }else{
                                return <div>--</div>
                            }
                        }

                    },
                    {
                        title: '公式',
                        key: 'billingCategoryFormula',
                        render:(h,{ row, index })=>{
                            return <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><Tooltip content={row.billingCategoryFormula}>{row.billingCategoryFormula}</Tooltip></div>
                        }
                    },
                    {
                        width:this.billtype == 3 ? 'auto':0,
                        title: '计费公式',
                        render:(h,{ row, index })=>{
                            if(this.type == 'query' ){
                                return <div>{row.formula}</div>
                            }else{
                                return h('vInput',{
                                    props: {
                                        size:'small',
                                        value:row.formula
                                    },
                                    on: {
                                        'input':(event) => {
                                            this.setValue(row,'formula',event)
                                            // row.formula = event
                                            // _this.datalist[index] = row
                                        }
                                    },
                                })
                            }
                        },
                    },
                    {
                        width:this.billtype == 1 ? 'auto':0,
                        title: '存储天数起',
                        render:(h,{ row, index })=>{
                            if(this.type != 'add' ){
                                return <div>{row.attachValue}</div>
                            }else{
                                return h('vInput',{
                                    props: {
                                        size:'small',
                                        value:row.attachValue
                                    },
                                    on: {
                                        'input':(event) => {
                                            // row.attachValue = event
                                            this.setValue(row,'attachValue',event)
                                            // _this.datalist[index] = row
                                        }
                                    },
                                })
                            }
                        },
                    },
                    {
                        width:this.billtype == 1 ? 'auto':0,
                        title: '存储天数止',
                        render:(h,{ row, index })=>{
                            if(this.type != 'add'){
                                return <div>{row.attachValue1}</div>
                            }else{
                                return h('vInput',{
                                    props: {
                                        size:'small',
                                        value:row.attachValue1
                                    },
                                    on: {
                                        'input':(event) => {
                                            // row.attachValue1 = event
                                            this.setValue(row,'attachValue1',event)
                                            // _this.datalist[index] = row
                                        }
                                    },
                                })
                            }
                        },
                    },
                    // {
                    //     title:'单价',
                    //     render:(h,{ row, index })=>{
                    //         if(this.querytype == 'query'){
                    //             return <div>{row.price}</div>
                    //         }else{
                    //             return h('vInput',{
                    //                 props: {
                    //                     size:'small',
                    //                     value:row.price
                    //                 },
                    //                 on: {
                    //                     'input':(event) => {
                    //                         // row.price = event
                    //                         _this.datalist[index].price = event
                    //                     }
                    //                 },
                    //             })
                    //         }
                    //     }
                    // },
                    {
                        title:'单价',
                        render:(h,{ row, index })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.price}</div>
                            }else{
                                return h('vInput',{
                                    props: {
                                        size:'small',
                                        value:row.price,
                                    },
                                    on: {
                                        'input':(event) => {
                                            // row.price = event
                                            // _this.datalist.map(item => {
                                            //     if(item.billingCategoryCode == row.billingCategoryCode){
                                            //         item.price = event
                                            //     }
                                            // })
                                            this.setValue(row,'price',event)
                                            // _this.datalist[index].price = event
                                        }
                                    },
                                })
                            }
                        }
                    },
                    {
                        title:'最低收费',
                        render:(h,{ row, index })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.minimumCharge}</div>
                            }else{
                                return h('vInput',{
                                    props: {
                                        size:'small',
                                        value:row.minimumCharge
                                    },
                                    on: {
                                        'input':(event) => {
                                            this.setValue(row,'minimumCharge',event)
                                            // _this.datalist[index.minimumCharge] = event
                                        }
                                    },
                                })
                            }
                        }
                    },
                    {
                        title:'最高收费',
                        render:(h,{ row, index })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.maximumCharge}</div>
                            }else{
                                return h('vInput',{
                                    props: {
                                        size:'small',
                                        value:row.maximumCharge
                                    },
                                    on: {
                                        'input':(event) => {
                                            this.setValue(row,'maximumCharge',event)
                                            // _this.datalist[index].maximumCharge = event
                                        }
                                    },
                                })
                            }
                        }
                    },
                    {
                        renderHeader:(h,params)=>{
                            return h('div',[
                                h('strong','生效日期'),
                                h('div',{
                                    style:{
                                        'display': this.showDate,
                                        'flex-direction': 'column',
                                        'justify-content': 'space-around',
                                        'align-items': 'flex-start'
                                    }
                                },[
                                    h('vDatepicker',{
                                        props:{
                                            transfer:true,
                                            placement:'top',
                                        },
                                        attrs: {
                                            placement:'top',
                                            type:'datetime',
                                            style:'width:100%',
                                            placeholder:"Select date",
                                            clearable:true,
                                            format:'yyyy-mm-dd',
                                            confirm: false,
                                        },
                                        style:{
                                            'margin-top': '5px'
                                        },
                                        on: {
                                        'on-change':function(date,value){
                                            _this.startAllTime = date;
                                        },
                                    },
                                    }),
                                    h('Button', {
                                        props: {
                                          type: "gray",
                                          size: 'small',
                                        },
                                        on: {
                                          click: this.setStartTime
                                        },
                                        style: {
                                            'margin-top': '5px'
                                        }
                                    }, '批量设置')
                                ])
                            ])
                        },
                        render:(h,{ row, index })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.startTime}</div>
                            }else{
                                return h('vDatepicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'datetime',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        // clearable:true,

                                        format:'yyyy-mm-dd',
                                        confirm: false,
                                        // value:_this.datalist[index].startTime
                                        value:  _this.datalist.filter(item => item.billingCategoryCode == row.billingCategoryCode)[0].startTime
                                    },
                                    on: {
                                        'on-change':function(date,value){
                                            _this.datalist.filter(item => {
                                                if(item.billingCategoryCode == row.billingCategoryCode){
                                                    item.startTime = date
                                                }
                                            })
                                            // console.log(date,value,'startTime')
                                            // _this.datalist[index].startTime = date
                                        },
                                    },
                                })
                            }
                        }
                    },
                    {
                        renderHeader:(h,params)=>{
                            return h('div',[
                                h('strong','失效日期'),
                                h('div',{
                                    style:{
                                        'display': this.showDate,
                                        'flex-direction': 'column',
                                        'justify-content': 'space-around',
                                        'align-items': 'flex-start'
                                    }
                                },[
                                    h('vDatepicker',{
                                        props:{
                                            transfer:true,
                                            placement:'top',
                                        },
                                        attrs: {
                                            placement:'top',
                                            type:'datetime',
                                            style:'width:100%',
                                            placeholder:"Select date",
                                            clearable:true,
                                            format:'yyyy-mm-dd',
                                            confirm: false,
                                        },
                                        style:{
                                            'margin-top': '5px'
                                        },
                                        on: {
                                            'on-change':function(date,value){
                                                _this.endAllTime = date;
                                        },
                                    },
                                    }),
                                    h('Button', {
                                        props: {
                                          size: 'small',
                                        },
                                        on: {
                                          click: this.setEndTime
                                        },
                                        style: {
                                            'margin-top': '5px'
                                        }
                                    }, '批量设置')
                                ])
                            ])
                        },
                        render:(h,{ row, index })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.endTime}</div>
                            }else{
                                return h('vDatepicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'datetime',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        // clearable:true,
                                        format:'yyyy-mm-dd',
                                        confirm: false,
                                        // value:_this.datalist[index].endTime
                                        value:  _this.datalist.filter(item => item.billingCategoryCode == row.billingCategoryCode)[0].endTime
                                    },
                                    on: {
                                        'on-change':function(date,value){
                                            _this.datalist.filter(item => {
                                                if(item.billingCategoryCode == row.billingCategoryCode){
                                                    item.endTime = date
                                                }
                                            })
                                            // console.log(date,value,'endTime')
                                            // _this.datalist[index].endTime = date
                                        },
                                    },
                                })
                            }
                        }
                    },
                    // {
                    //     title: '操作',
                    //     width: this.type == 'query' ? 0 : 100,
                    //     render: ( h ,{row}) => {
                    //         if( row.currentStatus == 0){
                    //             return h('div',[
                    //                 h('Button', {
                    //                     props: {
                    //                       size: 'small',
                    //                     },
                    //                     on: {
                    //                       click: () => this.setValue(row,'currentStatus',1)
                    //                     },
                    //                     style: {
                    //                     }
                    //                 }, '编辑')
                    //             ])
                    //         }else{
                    //             return h('div',[
                    //                 h('Button', {
                    //                     props: {
                    //                       size: 'small',
                    //                     },
                    //                     on: {
                    //                         click: () => {
                    //                             this.submit(1,row);
                    //                         }
                    //                     },
                    //                     style: {
                    //                     }
                    //                 }, '保存'),
                    //                 h('Button', {
                    //                     props: {
                    //                       size: 'small',
                    //                     },
                    //                     on: {
                    //                     click: () => this.update()
                    //                     },
                    //                     style: {
                    //                     }
                    //                 }, '取消'),
                    //             ])
                    //         }
                    //     }
                    // },
                    {
                        title:'创建人',
                        width: this.type == 'query' ? 60 : 0,
                        render:(h,{ row })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.createdName}</div>
                            }
                        }
                    },
                    {
                        title:'创建时间',
                        width: this.type == 'query' ? 75 : 0,
                        render:(h,{ row })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.createdAt}</div>
                            }
                        }
                    },
                    {
                        title:'更新人',
                        width: this.type == 'query' ? 60 : 0,
                        render:(h,{ row })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.updatedName}</div>
                            }
                        }
                    },
                    {
                        title:'更新时间',
                        width: this.type == 'query' ? 75 : 0,
                        render:(h,{ row })=>{
                            if(this.querytype == 'query'){
                                return <div>{row.updatedAt}</div>
                            }
                        }
                    },
                ]
            }
        },
        methods:{
            closemodalprops(){
                this.modalProps = {};
                this.$emit('on-openCloseable');
            },
            async changeNewDatalist(val){
                this.loading = true
                await setTimeout(()=>{
                    this.newDatalist = this.datalist.filter(item=>{
                        for( let i=0;i<val.length;i++){
                            if(item.billingCategoryName.split('-规')[0] == val[i])
                            return item
                        }
                    })
                    this.newDatalist.sort(this.dataSort)
                },0);
                this.loading = false
            },
            importExcel(){
                this.modalProps = {
                    show: true,
                    title: '导入数据',
                    width:460,
                    showFooter: false,
                    action: process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/expenseCategoryPriceItem/importItems",
                    name: "excelFile",
                    component: "compUpload",
                    data: {
                        expenseCategoryCustomizeCode: this.code,
                        contextId: global.SYSID
                    },
                    download: () => {
                        this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/newBilling/expenseCategoryPriceItem/itemTemplate',{
                            expenseCategoryCustomizeCode: this.code,
                            contextId: global.SYSID
                        },'download')
                    },
                    on:{
                        'on-success':(res)=>{
                            this.modalProps={},
                            this.update();
                        }
                    }
                }
            },
            exportExcel() {
                this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/expenseCategoryPriceItem/export", {expenseCategoryCustomizeCode:this.code}, 'download')
            },
            setStartTime(){
                if(this.startAllTime){
                    this.newDatalist.map(item=>{
                        this.$set(item,'startTime',this.startAllTime)
                    })
                }

            },
            setEndTime(){
                if(this.endAllTime){
                    this.newDatalist.map(item=>{
                        this.$set(item,'endTime',this.endAllTime)
                    })
                }
            },
            setValue(obj,attr,value){
                this.datalist.map(item => {
                    if(item.billingCategoryCode == obj.billingCategoryCode){
                        this.$set(item,attr,value);
                    }
                })
            },
            dataSort(a,b){
                    if( a.billingCategoryName !== b.billingCategoryName ) return a.billingCategoryName < b.billingCategoryName ? -1 : 1
                    if( !a.groupName || !b.groupName ){
                        return -1
                    }else{
                        if( a.groupName !== b.groupName ) return a.groupName < b.groupName ? -1 : 1
                        else if( a.code !== b.code ) return a.code < b.code ? -1 : 1
                    }
            },
            handleCheckAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;
                if (this.checkAll) {
                    this.countDataList = this.querytype == 'query' ? this.countDataListQuery : this.countData

                } else {
                    this.countDataList = [];
                }
            },
            checkAllGroupChange(data){
                if (data.length === 7) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            },
            getbillingUnit(num){
                return this.billUnitEnum.filter(item=>{ return item.value === num })[0].label || '--'
            },
            getbillConditionEnum(num){
                // console.log(num)
                if(num == 0){
                    return '--'
                }else{
                    let oneData = this.billConditionEnum.filter(item=>{ return item.value == num })
                    if(oneData.length>0){
                        return oneData[0].label
                    }else{
                        return '--'
                    }
                    // return this.billConditionEnum.filter(item=>{ return item.value == num })[0].label || '--'
                }
            },
            update(){

                if(this.type == 'add') return
                // 日志
                // if(this.type == 'query'){
                //     HttpSysOpLog({
                //         'search[EQ_opData]':this.id,
                //         'search[EQ_opModel]':'Product_Development_Recommend',
                //         row:1000,
                //         page:1,
                //     }).then(res=>{
                //         this.logList = res.data.content
                //     },err=>{
                //         this.$Message.error(err.message);
                //     })
                // }
                // console.log(this.activeid)
                this.loading = true;
                const p1 = HttpGetPriceMaintianBase({
                    code:this.code,
                }).then(res=>{
                    this.formData = res.data;
                },err=>{
                    this.$VMessage.error(err.message);
                })
                const p2 = HttpGetPriceMaintianTable({
                    expenseCategoryCustomizeCode:this.code,
                    organizationId:this.orgid
                }).then(res=>{
                    this.datalist = res.data;
                    this.newDatalist = this.datalist
                    const dataName = res.data.map(item => {
                        return item.billingCategoryName.split('-')[0]
                    });
                    this.countData = dataName.filter( (item,index) => {
                        return dataName.indexOf(item) === index
                    })
                    this.countData.sort();
                    const selectedName = res.data.filter(item=> item.status == 1).map(item => {
                        return item.billingCategoryName.split('-')[0]
                    });
                    this.countDataList = selectedName.filter( (item,index) => {
                        return selectedName.indexOf(item) === index
                    })
                    this.countDataListQuery = this.countDataList
                },err=>{
                    this.$VMessage.error(err.message);
                })
                Promise.all([p1,p2]).then((res)=>{
                    this.loading = false;
                },err=>{
                    this.$VMessage.error(err.message);
                })
            },
            async submit(params){
                const lastList = this.datalist.map(item=>{
                    if(this.countDataList.indexOf(item.billingCategoryName.split('-')[0]) > -1){
                        item.status = 1
                    } else{
                        item.status = 0
                    }
                    // this.countDataList.map( i => {
                    //     if(item.billingCategoryName.indexOf(i)>-1){
                    //         item.status=1
                    //     }
                    // })
                    return item
                });
                let flag = false;
                await this.$refs.relation.validate(valid => {
                    if (!valid) return flag = true
                });
                if (flag) return this.$VMessage.error('请填写必填项');
                let priceflag = false;
                // console.log(this.datalist,'this.datalist')
                // 判断填写了单价，当前行的日期必填
                for(let i=0;i<this.datalist.length;i++){
                    if(this.datalist[i].price&&this.datalist[i].price!=0){
                        // console.log(this.datalist[i].price,this.datalist[i].startTime,this.datalist[i].endTime)
                        if(!this.datalist[i].startTime || !this.datalist[i].endTime){
                            priceflag = true
                        }
                    }
                }
                if(priceflag){
                    this.$VMessage.error('填写单价行的日期必填');
                    return
                }
                this.loading = true;
                HttpSavePriceMaintiantTable({
                    data:lastList
                }).then(res=>{
                    this.$Message.success('保存成功');
                    this.cancel();
                    this.loading = false;
                },err=>{
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                    this.loading = false;
                })
            },

            cancel(){
                this.$router.push({
                    name: 'payPricemaintain',
                })
            },
        }
    }
</script>
   

